import {
  UserSettingsObjectType,
  requestingUserSettings,
  receivedUserSettings,
  settingUserSettings,
  setUserSettings,
} from '~/actions/couples/types/userSettingsActionTypes';
import { AppThunk } from '~/reducers';
import { UserSettingView } from '~/types/responseTypes';
import { StandardLogFn } from '~/util/logger';

import { loadUserSettings, recordUserSetting } from '../util/userSettingsApi';

export const fetchUserSettings = (
  keys: string[]
): AppThunk<Promise<UserSettingsObjectType | void>> => {
  return (dispatch) => {
    dispatch(requestingUserSettings());
    return loadUserSettings(keys)
      .then((data) => {
        if (data) {
          dispatch(receivedUserSettings(data));
          return data;
        }
        return undefined;
      })
      .catch((error) => {
        StandardLogFn(error);
      });
  };
};

export const setUserSetting = (key: string | null): AppThunk<Promise<void>> => {
  return (dispatch) => {
    if (key) {
      dispatch(settingUserSettings());
      recordUserSetting(key)
        .then((response) => {
          if (response.data) {
            const userSettingsObject: UserSettingsObjectType = {
              // The date types don't line up, one is "Date" and one is String|null
              [key]: response.data as unknown as UserSettingView,
            };
            dispatch(setUserSettings(userSettingsObject));
          }
        })
        .catch(StandardLogFn);
    }

    return Promise.resolve();
  };
};
